var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardtick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 31,
    fill: "#1B1B1B"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 122",
    clipPath: "url(#clip0_33_16735)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 12426,
    transform: "translate(-418 -4820)",
    fill: "#FAFDFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 48098153"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 32"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Card 8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    filter: "url(#filter0_d_33_16735)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -25,
    y: -316,
    width: 533.333,
    height: 746.667,
    rx: 24,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Frame 36"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 28"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 25"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 12",
    cx: 15.4839,
    cy: 15.5293,
    r: 15.4707,
    fill: "#4176D4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2",
    d: "M8.34375 14.9344L13.104 19.6946L22.0294 10.7692",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_33_16735",
    x: -49.6,
    y: -336.6,
    width: 582.533,
    height: 795.867,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.290196 0 0 0 0 0.588235 0 0 0 0 0.964706 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33_16735"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33_16735",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_33_16735"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 12426,
    fill: "white",
    transform: "translate(-418 -4820)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardtick);
export default __webpack_public_path__ + "static/media/cardtick.0e4fab0cb01924bb071d30a49c5e0183.svg";
export { ForwardRef as ReactComponent };